import { LadderSteps, WeekProgress, LevelUpPrompt } from "@/components/ladder/LadderParts";

export function HabitLadder({ habit, onLevelUp }) {
  return (
    <div className="mt-4 space-y-3" data-testid={`ladder-${habit.id}`}>
      <LadderSteps habit={habit} />
      <WeekProgress habit={habit} />
      <LevelUpPrompt habit={habit} onLevelUp={onLevelUp} />
    </div>
  );
}
